// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../../utils/colors.css\"","grey":"#898581","greyedOut":"CartSummary_greyedOut__2kp_P"};